import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageAnnemasse: React.FC = () => (
  <LocalSeoPage
    city="Annemasse"
    slug="depannage-informatique-annemasse"
    metaTitle="Dépannage informatique Annemasse | Technicien PC | SOS IT"
    metaDescription="Dépannage PC et Mac à Annemasse. Suppression virus, récupération de données, optimisation. Rapide et efficace. Appelez !"
    intro="Votre ordinateur vous lâche à Annemasse ? Virus, PC lent, panne Windows ou problème de réseau — nos techniciens interviennent rapidement à votre domicile. Diagnostic gratuit et devis clair avant toute intervention."
    postalCode="74100"
    cityFaqs={[
      { question: "Quel est le délai pour une intervention à domicile à Annemasse ?", answer: "Annemasse se trouve à environ 25 minutes de Viry. Le délai dépend de notre planning du moment : appelez-nous ou écrivez sur WhatsApp, nous vous proposons un créneau. Réponse en moins de 2h, 7j/7, intervention souvent le jour même." },
      { question: "Mon ordinateur de télétravail est en panne à Annemasse, pouvez-vous intervenir ?", answer: "Oui, nous intervenons à votre domicile, déplacement inclus. Si l'ordinateur est fourni par votre employeur, vérifiez d'abord auprès de votre service informatique ce que vous êtes autorisé à modifier." },
    ]}
    travelTime="≈ 25 min de Viry"
    phoneRepairLink={{ label: "Réparation téléphone à Annemasse", href: "/reparation-telephone-annemasse" }}
    nearbyTowns={[
      { name: 'Saint-Julien-en-Genevois', link: '/depannage-informatique-saint-julien-en-genevois' },
      { name: 'Viry', link: '/depannage-informatique-viry' },
      { name: 'Annecy', link: '/depannage-informatique-annecy' },
      { name: 'Gaillard' },
      { name: 'Ambilly' },
      { name: 'Ville-la-Grand' },
      { name: 'Cranves-Sales' },
    ]}
    internalLinks={[
      { label: 'Création de site internet à Annemasse', href: '/creation-site-internet-annemasse' },
      { label: 'Dépannage informatique à Saint-Julien-en-Genevois', href: '/depannage-informatique-saint-julien-en-genevois' },
      { label: 'Dépannage informatique à Viry', href: '/depannage-informatique-viry' },
      { label: 'Dépannage informatique à Annecy', href: '/depannage-informatique-annecy' },
      { label: 'Dépannage informatique autour de Genève', href: '/depannage-informatique-geneve' },
    ]}
  />
);

export default DepannageAnnemasse;
